import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../core/config/environment";

export interface ReportSasResponse {
  reportSasUrl: string;
}

export interface ProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
  retryAtUtc?: string;
}

@Injectable({
  providedIn: "root"
})
export class ReportService {

  constructor(private http: HttpClient) { }

  getReportSasUrl(externalLotId: number, reportStep: string): Observable<ReportSasResponse> {
    const params = new HttpParams().set("reportStep", reportStep);
    return this.http.get<ReportSasResponse>(`${environment.backend.apiBaseURL}/api/reports/${externalLotId}`, { params });
  }
}
